module.exports = __webpack_public_path__ + "img/course86_curriculum.4aee53f2.png";